module.exports = __webpack_public_path__ + "static/media/colleen_odea.2cf3d195.jpg";